module.exports = __webpack_public_path__ + "img/3.d673c760.jpg";